var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCloudDownload = function SvgCloudDownload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 44,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.212 16.61C51.343 7.122 43.01 0 33 0c-7.948 0-14.85 4.51-18.288 11.11C6.435 11.99 0 19.003 0 27.5 0 36.602 7.397 44 16.5 44h35.75C59.84 44 66 37.84 66 30.25c0-7.26-5.638-13.145-12.788-13.64Zm-6.462 8.14L33.962 37.538c-.55.55-1.402.55-1.952 0L19.25 24.75h8.25v-11h11v11h8.25Z",
    fill: "#595959"
  })));
};

export default SvgCloudDownload;